module.exports = __webpack_public_path__ + "pc/img/ico-e.90293e0b.svg";